export const widthProperty = ['width', 'w'];
export const heightProperty = ['height', 'h'];
export const chartDataProperty = ['chartData', 'chd'];
export const chartCategoryProperty = ['chartCategory', 'c'];
export const chartSeriesProperty = ['chartSeries', 'cs'];
export const chartLegendProperty = ['chartLegend', 'cl'];
export const chartPrimaryCategoryAxisProperty = ['chartPrimaryCategoryAxis', 'cpca'];
export const chartPrimaryValueAxisProperty = ['chartPrimaryValueAxis', 'cpva'];
export const chartTitleProperty = ['chartTitle', 'ctt'];
export const chartTypeProperty = ['chartType', 'ct'];
export const trendLinesProperty = ['trendLines', 'tl'];
export const dataPointsProperty = ['dataPoints', 'dp'];
export const seriesNameProperty = ['seriesName', 'sn'];
export const dataLabelProperty = ['dataLabel', 'sl'];
export const errorBarProperty = ['errorBar', 'eb'];
export const fillProperty = ['fill', 'f'];
export const lineProperty = ['line', 'l'];
export const rgbProperty = ['rgb', 'rgb'];
export const idProperty = ['id', 'i'];
export const foreColorProperty = ['foreColor', 'fc'];
export const positionProperty = ['position', 'p'];
export const typeProperty = ['type', 't'];
export const nameProperty = ['name', 'n'];
export const directionProperty = ['direction', 'dir'];
export const endStyleProperty = ['endStyle', 'est'];
export const forwardProperty = ['forward', 'fw'];
export const backwardProperty = ['backward', 'bw'];
export const interceptProperty = ['intercept', 'itr'];
export const categoryTypeProperty = ['categoryType', 'ct'];
export const hasMajorGridLinesProperty = ['hasMajorGridLines', 'hmajgl'];
export const hasMinorGridLinesProperty = ['hasMinorGridLines', 'hmingl'];
export const majorUnitProperty = ['majorUnit', 'maju'];
export const isAutoMajorProperty = ['isAutoMajor', 'iam'];
export const maximumValueProperty = ['maximumValue', 'maxv'];
export const minimumValueProperty = ['minimumValue', 'minv'];
export const categoryXNameProperty = ['categoryXName', 'cx'];
export const numberFormatProperty = ['numberFormat', 'nf'];
export const yValueProperty = ['yValue', 'y'];
export const sizeProperty = ['size', 'sz'];
export const seriesFormatProperty = ['seriesFormat', 'sf'];
